/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'jquery',
	'../../../app/nls/StringResources'
], function ($, resources) {

	class ErrorView {
		renderContainer(data) {
			return $('<div class="errorContainer error">Error: ' + this.makeNlsMessage(data.msg) + '</div>' );
		}

		makeNlsMessage(msg){
			return msg.params ? resources.get(msg.str, msg.params) : resources.get(msg.str);
		}
	}

	return ErrorView;
});